import { render, staticRenderFns } from "./EditMetalModal.vue?vue&type=template&id=7e2aea44"
import script from "./EditMetalModal.vue?vue&type=script&lang=js"
export * from "./EditMetalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports